// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6db0ca10","946":"a6248530"}[chunkId] + ".chunk.js";
};